import styled, { css } from 'styled-components';
import { Text } from 'src/checkout/components/sections/payment/dutchie-pay';
// Layout
const flexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Section = styled.div`
  ${({ theme: { spaces } }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spaces[2]};
    align-self: stretch;
    margin-bottom: ${spaces[18]};
  `}
`;

export const PaymentCard = styled.div<{ error?: boolean }>`
  ${flexCenter}
  ${({ theme: { spaces, colors }, error }) => css`
    padding: ${spaces[4]} ${spaces[3]};
    flex-direction: column;
    align-self: stretch;
    border-radius: 5px;
    border: 1px solid ${error ? colors.red[55] : '#d8dee3'};
    background: ${colors.white};
    flex: 1;
  `}
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: ${({ theme: { spaces } }) => spaces[1]};
`;

export const BankInfo = styled.div`
  ${({ theme: { spaces } }) => css`
    display: flex;
    align-items: center;
    gap: ${spaces[2]};
    flex: 1; /* Takes available space and prevents overflow */
    min-width: 0; /* Allows content to truncate */
  `}
`;

export const Title = styled(Text)`
  font: normal 400 13px/18px;
  color: ${({ theme: { colors } }) => colors.grey[30]};
  letter-spacing: 0.065px;
`;

export const BankText = styled.div`
  ${flexCenter}
  color: #4b5257;
  font: normal 400 13px/120% 'Matter';
  min-width: 0; /* Allows BankText to truncate */
`;
export const BankName = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const DotSeparator = styled.span`
  margin: 0 4px;
`;
